export default __webpack_public_path__ + "static/media/Brow_6_C1.3253dbfc.svg";